import { CitiesByPrefectureApiResponseType, FetchCitiesByPrefectureErrorResponseType, FetchCitiesByPrefectureExecuteReturnType } from './types';

export const fetchCitiesByPrefectureExecute = async (
  searchParams: URLSearchParams,
): Promise<FetchCitiesByPrefectureExecuteReturnType> => {
  try {
    const response: Response = await fetch(`/api/address/current_cities_by_prefecture?order=yomi&${searchParams.toString()}`);
    const citiesData: CitiesByPrefectureApiResponseType = await response.json();

    return {
      response,
      citiesData,
      errorResponse: null,
    };
  } catch (error) {
    const response: Response = await error.response;
    const errorResponse: FetchCitiesByPrefectureErrorResponseType = await response.json();

    return {
      response,
      citiesData: null,
      errorResponse,
    };
  }
};
